import React from 'react';

import SEO from '../components/seo';
import Subheader from '../components/subheader';
import { GraphQLData } from '../types';
import { getLocalizationObj } from '../utilities/getLocalizationObj';
import { PraxisTemplateMain } from './praxisMain';

interface PraxisProps {
  data: GraphQLData;
  location: any;
}

export const PraxisTemplate = ({ location, data }: PraxisProps) => {
  const { subheader, meta } = getLocalizationObj(data.strapi?.praxi) || {};
  const { title = 'Praxis', description } = meta ?? {};

  return (
    <>
      <SEO description={description} title={title} />
      <Subheader intro={subheader} />
      <PraxisTemplateMain data={data} location={location} />
    </>
  );
};
